/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React, { useContext, useState } from 'react'
import AnimatedPage from '../../components/Animation/AnimatedPage'
import { userService } from '../../services/user.services';
import GlobalContext from '../../components/Context/GloablContext';
import { validateEmail } from '../../CommonMethods/EmailValidator';
import Loader from '../../components/Loader';

export default function ForgotPassword({
    setIsForgotPassword,
    handelClear,emailFromLogin,
}) {
    const [email, setEmail] = useState(''+emailFromLogin);
    const {setToastmessage, setToastErrorMessage} = useContext(GlobalContext)
    const [emailValidation, setEmailValidation] = useState(false)
    const [loading, setLoading] = useState(false)
    const [clearEmail, setClearEmail] = useState(emailFromLogin===''?true:false)

    /**
     * The function `handleResetLink` is used to handle the logic for sending a forgot password link to
     * the user's email address.
     */
    const handleResetLink = async() => {
        setLoading(true)
        if(validateEmail(email.trim())) {
            setEmailValidation(true);
            setLoading(false)
            setToastErrorMessage("Invalid Email Address"); 
        } else{
            try {
                const response = await userService.forgotPassword(`users/forgot-password-send-link/${email}`, {});   
                setToastmessage(response.data.message)
                setIsForgotPassword(false);
                setLoading(false)
            } catch (error) {
                setToastErrorMessage("Invalid Email Address"); 
                setLoading(false)
            }
        }
    }

    const clearEmailAddress = (e) => {
        setClearEmail(true);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const emailToSend = clearEmail ? email : emailFromLogin;
        handleResetLink(emailToSend);
    }

    return (
        <AnimatedPage>
            <div className='relative'>
                <div class="w-full flex flex-col items-center h-screen shadow-s1 login-section">
                    <div class="ml-4 absolute top-[10%] left-0">
                        <p onClick={() => {setIsForgotPassword(false); handelClear()}} class="flex items-center backBtnLogin cursor-pointer">
                            <span><img loading="lazy" decoding="async" src="/images/back-btnBlue.svg" alt="btn"/></span>
                            <span class="pl-3 text-lg font-medium text-[#106EB4]">Back</span>
                        </p>
                    </div>
                    {/* <!-- forgot password section --> */}
                    <div class="mx-auto  top-[15%] absolute">
                        <img loading="lazy" decoding="async" src="/images/SkuTeq-Logo.svg" alt="product-logo" class="mx-auto"/>
                        <p class="text-center pt-[32px] text-xl font-semibold text-[#031624] login-page-errShow">Forgot Password</p>
                        <div class="mx-auto">
                            <div class="w-[350px]">
                                <p class="pt-8 text-[#031624] text-center">{clearEmail
                                    ? "Please enter your registered Email Address to receive a password reset link."
                                    : "The Email Address you entered is displayed below. Click 'Change' if you wish to modify it."
                                }</p>
                                {/* <!-- error mesaage  --> */}
                                <p class="text-f4 font-normal text-[#F04438] mt-[32px] login-err hidden text-center">Incorrect username or password</p>
                                <form  onSubmit={handleSubmit} class="mt-[32px]">
                                    <div class="flex flex-col">
                                        <label for="emailAddress" class="text-f1 font-[500] text-[#344054] pb-1.5">Email Address</label>
                                        {clearEmail && <input
                                            type="text" 
                                            id="emailAddress" 
                                            value={email}
                                            autoComplete='off'
                                            onChange={(e) => {setEmail(e.target.value); setEmailValidation(false)}}
                                            class={`w-full border  ${emailValidation ? "border-[#F04438]" : "border-[#D0D5DD]"} rounded py-2.5 px-3.5 outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#101828] err-border`}
                                            placeholder="Enter Email Address"
                                        />}
                                        {!clearEmail && <div class="w-full border rounded py-2.5 px-3.5 inline-flex outline-0">
                                            <span class="break-all pr-[14px]">{email}</span>
                                            <a class="text-f7 font-semibold text-[#106EB4] inline-flex cursor-pointer items-center" onClick={() =>clearEmailAddress()}>Change</a>
                                        </div>}
                                    </div>
                                    <button
                                        type="submit"
                                        // onClick={() =>handleResetLink()}
                                        class="w-full bg-[#106EB4] py-3 rounded mt-5 text-f2 font-normal text-[#ffffff] resend-otp hover:bg-[#1C8ADC] hover:duration-75 ltr-spcng-6" id="login_btn">
                                        {loading ? <Loader /> : "Request Reset Link"}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AnimatedPage>
    )
}
